var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.href)?_c('a',_vm._b({attrs:{"href":_vm.href,"target":"_blank"}},'a',_vm.$attrs,false),[_vm._t("default")],2):_c('RouterLink',_vm._b({attrs:{"to":_vm.routerLinkTo}},'RouterLink',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }